import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from 'vuex-module-decorators';
import store from '../index';

export interface ErrorState {
  message: string;
  hasError: boolean;
  isLoading: boolean;
}

@Module({ dynamic: true, store, name: 'error' })
class ErrorModule extends VuexModule implements ErrorState {
  message = '';

  hasError = false;

  isLoading = false;

  @Mutation
  SET_ERROR(error: string): void {
    this.message = error;
    this.hasError = true;
  }

  @Mutation
  SET_LOADING(loadingStatus: boolean): void {
    this.isLoading = loadingStatus;
  }

  @Mutation
  PURGE_ERROR(): void {
    this.message = '';
    this.hasError = false;
  }

  @Action
  throwError(error: string): void {
    this.SET_ERROR(error);
  }

  @Action
  clearError(): void {
    this.PURGE_ERROR();
  }

  @Action
  setLoading(loadingStatus): void {
    this.SET_LOADING(loadingStatus);
  }
}

export default getModule(ErrorModule);
